module.exports = __webpack_public_path__ + "img/size3.87525063.png";